import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { translate } from '~l10n/client';

import { startTimerActivity } from '../../../src/api/activities/startTimerActivity';
import { TimerConfirmationView } from '../views/TimerConfirmationView';

const activity = require('activity');

function TimerConfirmationController() {
  this.isLoading = false;
  this.errorMessage = null;
  this.callback = null;
}

TimerConfirmationController.prototype = {
  render: function (callback) {
    const timerSeconds = activity.get('settings')?.quiz_timer_seconds;

    if (!timerSeconds) {
      console.error('Timer seconds not found in activity settings');
      return;
    }

    this.callback = callback;

    this.renderView(timerSeconds);
  },

  renderView: function (timerSeconds) {
    ReactDOM.render(
      <TimerConfirmationView
        timerSeconds={timerSeconds}
        onStartClicked={() => this.handleStartClicked()}
        errorMessage={this.errorMessage}
        isLoading={this.isLoading}
        onDismissError={() => this.dismissError(timerSeconds)}
      />,
      document.getElementById('main-content')
    );
  },

  dismissError: function (timerSeconds) {
    this.errorMessage = null;
    this.renderView(timerSeconds);
  },

  handleStartClicked: async function () {
    this.isLoading = true;
    this.errorMessage = null;
    const timerSeconds = activity.get('settings')?.quiz_timer_seconds;
    this.renderView(timerSeconds);

    try {
      await startTimerActivity(activity.get('id'));

      this.isLoading = false;

      // Unmount the confirmation view before proceeding
      const mainContent = document.getElementById('main-content');
      if (mainContent) {
        ReactDOM.unmountComponentAtNode(mainContent);
      }

      if (this.callback) {
        this.callback();
      }
    } catch (error) {
      this.isLoading = false;
      this.errorMessage = translate(
        "Couldn't start the timer. Check your connection and try again."
      );
      this.renderView(timerSeconds);
      console.error('Failed to start activity:', error);
    }
  },
};

const controller = new TimerConfirmationController();
module.exports = controller;
